import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@xo-union/tk-component-switches';
import styles from './checkbox.scss';

const CheckboxIA = ({ id, onClick, checked }) => (
  <div className={styles.checkboxContainer}>
    <Checkbox id={id} checked={checked} onChange={onClick} />
  </div>
);

CheckboxIA.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CheckboxIA;
